import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-catalog",
  "use": "icon-catalog-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-catalog\"><defs><style type=\"text/css\"></style></defs><path d=\"M960 378.24a90.88 90.88 0 0 0-58.24-32v-35.2a99.84 99.84 0 0 0-99.2-99.84H538.88l-39.04-56.32A71.04 71.04 0 0 0 444.8 128H108.16a58.88 58.88 0 0 0-44.16 58.88v611.2A99.84 99.84 0 0 0 165.12 896h640a114.56 114.56 0 0 0 110.72-88.96l64-348.8A97.92 97.92 0 0 0 960 378.24zM128 192h320l58.24 83.2h297.6a35.84 35.84 0 0 1 35.2 35.84v33.92H158.08a94.72 94.72 0 0 0-24.96 3.84H128V192z m789.12 256l-64 348.8a51.2 51.2 0 0 1-48 37.12h-640a35.84 35.84 0 0 1-37.12-36.48V433.28a26.24 26.24 0 0 1 28.16-24.32h729.6a29.44 29.44 0 0 1 23.68 10.24 33.92 33.92 0 0 1 7.68 28.8z\" fill=\"#24292e\" p-id=\"6416\" data-spm-anchor-id=\"a313x.7781069.0.i18\" class=\"selected\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/catalog.svg
// module id = SZh0
// module chunks = 2